var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-table-row',[(_vm.canSelected)?_c('index-table-cell',{staticClass:"text-center"},[_c('md-checkbox',{model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }